import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineTable } from "react-icons/ai";
import { TextField } from "@mui/material";
import { MenuItem } from "@mui/material";

import Sidebar from "../../../Sidebar/Sidebar";
import { BsPencilSquare } from "react-icons/bs";
import "../CpvCases/CpvCases.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import Cookies from 'js-cookie';

const CpvCases = () => {
  const [open, setOpen] = React.useState(false);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  // const [cpvDrop, setcpvDrop] = useState("LOAN ID");
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [query, setQuery] = useState("");
  const [borrowerModal, setborrowerModal] = useState([]);
  const [statusModal, setstatusModal] = useState(false);
  const [data, setData] = useState([]);
  const [showborrower, setShowborrower] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [BorrowerUniqueNo, setBorrowerUniqueNo] = useState("");
  const [loanStatus, setloanStatus] = useState("");
  const [currentAddressCPV, setcurrentAddressCPV] = useState("");
  const [officeAddressCPV, setofficeAddressCPV] = useState("");
  const [permanentAddressCPV, setpermanentAddressCPV] = useState("");
  const [description, setdescription] = useState("");
  const [statusTrailArr, setStatusTrailArr] = useState([]);
  const [cpvIcon, setcpvIcon] = useState("");
  const [borrowerName, setBorrowerName] = useState("");

  const [currentAddressVisible, setcurrentAddressVisible] = useState("");
  const [officeAddressVisible, setofficeAddressVisible] = useState("");
  const [permanentAddressVisible, setpermanentAddressVisible] = useState("");


  const [rowNumber, setRowNumber] = useState(10);
  const navigate = useNavigate();
  var [pageCount, setPageCount] = useState(1);

  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  const getPageLoad = (e) => {
    // setOpen(true);
    if (e === "inc") {
      setPageCount((pageCount) => pageCount + 1);
    } else {
      setPageCount((pageCount) => pageCount - 1);
    }
  };
  useEffect(() => {

      setOpen(true);
    axios
      .post(url + "/cpv/getallcases", {
        token: token,
        email: email,
        pageSize: rowNumber,
        page: pageCount,
      })
      .then((res) => {
        // console.log(res);
        setOpen(false);
        if (res.data.logout === true) {
          setOpen(false);
          setTimeout(() => {
            toast.error(res.data.message);
            navigate("/");
          }, 3000);
        } 
        else if (res.data.auth === false) {
          setOpen(false);
          // toast.error(res.data.message);
        } else {
          setOpen(false);
          // console.log(res.data.message[0].cpv_status);
          if (res.data.message.length === 0 && pageCount > 1)
            return setPageCount((pageCount) => pageCount - 1);
          setData(res.data.message);
          setcpvIcon(res.data.message[0].cpv_status);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
      });
    }, [token,email,rowNumber,pageCount,navigate]);

  const serachDateApi = () => {
    setOpen(true);
    axios
      .post(url + "/cpv/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query,
      })
      .then((res) => {
        // console.log(res);
        setOpen(false);
        if (res.data.auth === false) {
          setOpen(false);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        }
        else {
          setOpen(false);
          if (res.data.message.length === 0) return setData([]);
          setData(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
        toast.error(err.message);
      });
  };

  const toggleBorrowerModal = (borrower_uniqueno, loan_id) => {
    setShowborrower(!showborrower);
    // console.log(borrower_uniqueno);
    // console.log(loan_id);
    setLoanId(loan_id);
    // setBorrowerUniqueNo(borrower_uniqueno);
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    setOpen(true);
    axios
      .post(url + "/borrower/getsingle", {
        token: token,
        email: email,
        borrower_uniqueno: borrower_uniqueno,
      })

      .then((res) => {
        // console.log(res);
        setborrowerModal(res.data);
        setOpen(false);
      })

      .catch((err) => {
        setOpen(false)
        toast.error(err.message);
      });
  };

  const cancelFunction = () => {
    setStatusTrailArr([]);
    setloanStatus("");
    setcurrentAddressCPV("");
    setofficeAddressCPV("");
    setpermanentAddressCPV("");
    setdescription("");
    setstatusModal(!statusModal);
  };

  const closeFunction = () => {
    setShowborrower(!showborrower);
  };

  const togglestatusModal = (borrower_uniqueno, loan_id, borrower_name) => {
     setstatusModal(!statusModal);
    setBorrowerName(borrower_name);
    setLoanId(loan_id);
    setBorrowerUniqueNo(borrower_uniqueno);
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    setOpen(true);
    axios
      .post(url + "/loan/statustrail", {
        token: token,
        email: email,
        loan_id: loan_id,
      })

      .then((res) => {
        
        // console.log(res.data.message);
        if (typeof res.data.message !== "object") {
          setOpen(false)
          toast.error("Please Enter Loan Status Trail in Prescribed Format.");
          return;
        }
        setStatusTrailArr(res.data.message);
        setOpen(false)
      })

      .catch((err) => {
        setOpen(false)
        toast.error(err.message);
      });

      setOpen(true);
    axios
      .post(url + "/cpv/getsinglecase", {
        token: token,
        email: email,
        loan_id: loan_id,
      })

      .then((res) => {
        // console.log(res);
        // console.log(res.data.message[0].cpv_type);
        // console.log(res.data.message[0].cpv_status);

        const selectedItemone = res.data.message[0].cpv_type.find(item => item === 'CURRENT ADDRESS CPV');
        const selectedItemtwo = res.data.message[0].cpv_type.find(item => item === 'OFFICE ADDRESS CPV');
        const selectedItemthree = res.data.message[0].cpv_type.find(item => item === 'PERMANENT ADDRESS CPV');

        setcurrentAddressVisible(selectedItemone)
        setofficeAddressVisible(selectedItemtwo);
        setpermanentAddressVisible(selectedItemthree);
        setOpen(false)
      })

      .catch((err) => {
        setOpen(false)
        toast.error(err.message);
      });
  };

  if (showborrower) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  if (statusModal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  const uploadCurrentAddress = (e) => {
    // setOpen(true);
    let currentAddress = e.target.files;
    if (e.target.files[0] === undefined) {
      // setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      toast.error("Please Upload Pdf File Only");
      return;
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(currentAddress[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);

      const token = Cookies.get('Token');
      const email = Cookies.get('Email');

      axios
        .post(url + "/cpv/adddocument", {
          token: token,
          email: email,
          borrower_uniqueno: BorrowerUniqueNo,
          doc_name: "current_add_doc",
          loan_id: loanId,
          doc_type: "pdf",
          fileName: base64_data,
        })

        .then((res) => {
          // console.log(res.data);
          // setborrowerModal(res?.data);
        })

        .catch((err) => {
          toast.error(err.message);
        });
    };
  };

  const uploadOfficeAddress = (e) => {
    // setOpen(true);
    let OfficeAddress = e.target.files;
    if (e.target.files[0] === undefined) {
      // setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      toast.error("Please Upload Pdf File Only");
      return;
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(OfficeAddress[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);

      const token = Cookies.get('Token');
      const email = Cookies.get('Email');

      axios
        .post(url + "/cpv/adddocument", {
          token: token,
          email: email,
          borrower_uniqueno: BorrowerUniqueNo,
          doc_name: "office_add_doc",
          loan_id: loanId,
          doc_type: "pdf",
          fileName: base64_data,
        })

        .then((res) => {
          // console.log(res.data);
          // setborrowerModal(res?.data);
        })

        .catch((err) => {
          toast.error(err.message);
        });
    };
  };

  const uploadPermanentAddress = (e) => {
    // setOpen(true);
    let permanentAddress = e.target.files;
    if (e.target.files[0] === undefined) {
      // setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      toast.error("Please Upload Pdf File Only");
      return;
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(permanentAddress[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);

      const token = Cookies.get('Token');
      const email = Cookies.get('Email');

      axios
        .post(url + "/cpv/adddocument", {
          token: token,
          email: email,
          borrower_uniqueno: BorrowerUniqueNo,
          doc_name: "permanent_add_doc",
          loan_id: loanId,
          doc_type: "pdf",
          fileName: base64_data,
        })

        .then((res) => {
          // console.log(res.data);
          // setborrowerModal(res?.data);
        })

        .catch((err) => {
          toast.error(err.message);
        });
    };
  };

  const handleSaveData = (e) => {
    e.preventDefault();
    setstatusModal(!statusModal);
    // console.log("ankit");
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');

    axios
      .post(url + "/loan/statuschange", {
        token: token,
        email: email,
        loan_id: loanId,
        loan_status: loanStatus,
        loan_status_desc: description,
      })

      .then((res) => {
        // console.log(res.data);
      })

      .catch((err) => {
        toast.error(err.message);
      });

    axios
      .post(url + "/cpv/done", {
        token: token,
        email: email,
        loan_id: loanId,
        current_add_cpv: currentAddressCPV,
        permanent_add_cpv: permanentAddressCPV,
        office_add_cpv: officeAddressCPV,
      })

      .then((res) => {
        // console.log(res.data);

        if (res.data.auth === false) {
          toast.error(res.data.message);
        } else {
          toast.success(res.data.message);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      })

      .catch((err) => {
        toast.error(err.message);
      });

    axios
      .post(url + "/loan/statustrail", {
        token: token,
        email: email,
        loan_id: loanId,
      })

      .then((res) => {
        // console.log(res.data);
      })

      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"CpvCases"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              CPV Cases Loans
            </h3>
            <div className="table-cpvcases-input-fields">
              {/* <div className="table-head-inputs">
                <label htmlFor="from-date">From Date</label>
                <TextField
                  className="lms-input-field"
                  size="small"
                  type="date"
                  variant="outlined"
                  id="from-date"
                  name="from-date"
                />
              </div> */}
              {/* <div className="table-head-inputs">
                <label htmlFor="to-date">To Date</label>
                <TextField
                  size="small"
                  type="date"
                  variant="outlined"
                  id="to-date"
                  name="to-date"
                />
              </div> */}
              {/* <div className="table-head-inputs">
                <label>Select Data</label>
                <TextField
                  className="input-field"
                  placeholder="Select Data..."
                  select
                  name="created-data"
                  variant="outlined"
                  value={cpvDrop}
                  size="small"
                  onChange={(e) => cpvData(e)}
                >
                  <MenuItem value="LOAN ID">Loan Id</MenuItem>
                  <MenuItem value="BORROWER NAME">Borrower Name</MenuItem>
                  <MenuItem value="STATUS">Status</MenuItem>
                </TextField>
              </div> */}
              <div className="table-head-inputs">
                {/* <label>Search Data</label> */}
                <TextField
                  placeholder="Loan Id / Borrower Id"
                  name="search-data"
                  id="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  variant="outlined"
                  size="small"
                  // sx={{ width: "30ch"}}
                />
              </div>
              <button className="digi-kyc" onClick={serachDateApi}>
                Search
              </button>
            </div>
            <div className="lms-table-div">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Loan Id</th>
                    <th>Borrower Id</th>
                    <th>Borrower Name</th>
                    <th>Branch Name</th>
                    <th>Loan Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 &&
                      data?.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td className="vert-color branch-pad">
                              {data.loan_id}
                            </td>
                            <td className="branch-pad">
                              {data.borrower_uniqueno}
                            </td>
                            <td
                              className="vert-color branch-pad hover-td"
                              onClick={() =>
                                toggleBorrowerModal(
                                  data.borrower_uniqueno,
                                  data.loan_id
                                )
                              }
                            >
                              {data.borrower_name}
                            </td>
                            <td className="vert-color branch-pad">
                              {data.cpv_branchname}
                            </td>
                            <Tooltip title="Update Status">
                            <td className="branch-pad">
                            {cpvIcon === "CPV INITIATED" ? (
                              <BsPencilSquare style={{marginRight:"1rem"}}
                              
                                onClick={() =>
                                  togglestatusModal(
                                    data.borrower_uniqueno,
                                    data.loan_id,
                                    data.borrower_name
                                  )
                                }
                              ></BsPencilSquare>
                               ) : ""} 
                               
                              {data.cpv_status}
                              
                            </td>
                            </Tooltip>
                            
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>

            <div className="pagination-div">
            <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div> 
              <div className="pagination-bar">
              <button
                  className="digi-kyc"
                  style={{marginLeft:"1rem"}}
                  onClick={() => getPageLoad("dec")}
                  disabled={pageCount === 1}
                >
                  Previous
                </button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>
                {pageCount}
              </span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>
                  Next
                </button>
              </div>
            </div>
          </div>

          {showborrower && (
            <div className="modal overlay">
              <div className="modal-content">
                <h2 style={{ width: "100%", textAlign: "center" }}>
                  All Details
                </h2>
                <br />
                <div className="lms-table-div-modal">
                  <table className="modal-table">
                    <tbody>
                      {borrowerModal.length > 0 &&
                        borrowerModal.map((data, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <th>Loan ID</th>
                                <td>{loanId}</td>
                              </tr>
                              <tr>
                                <th>Borrower ID</th>
                                <td>{data.borrower_uniqueno}</td>
                              </tr>
                              <tr>
                                <th>Borrower Name</th>
                                <td>
                                  {data.borrower_firstname +
                                    " " +
                                    data.borrower_middlename +
                                    " " +
                                    data.borrower_lastname}
                                </td>
                              </tr>
                              <tr>
                                <th>Borrower Phone number</th>
                                <td>{data.borrower_mobile}</td>
                              </tr>
                              <tr>
                                <th>Employer Name</th>
                                <td>{data.borrower_employer_name}</td>
                              </tr>
                              <tr>
                                <th>Business Name</th>
                                <td>{data.borrower_business_name}</td>
                              </tr>
                              <tr>
                                <th>Current Address</th>
                                <td>{data.borrower_current_address}</td>
                              </tr>
                              <tr>
                                <th>Office Address</th>
                                <td>{data.borrower_official_address}</td>
                              </tr>
                              <tr>
                                <th>Permanent Address</th>
                                <td>{data.borrower_permanent_address}</td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <br />
                <button className="close-modal" onClick={() => closeFunction()}>
                  CLOSE
                </button>
              </div>
            </div>
          )}

          {statusModal && (
            <div className="modal overlay">
              <div className="status-content">
                <div style={{ width: "100%", textAlign: "center" }}>
                  <h3>Status History of {borrowerName}</h3> <br />
                  <h4>HISTORY</h4>
                </div>
                <div className="history">
                  {
                  // statusTrainIsArr &&
                    statusTrailArr.length > 0 ?
                    statusTrailArr?.map((data, index) => {
                      return (
                        <div key={index} className="statusHistory">
                          <p>
                            <span>{data.loan_status_change_officer} </span>
                            changed status to <span>{data.loan_status}</span>
                          </p>
                          <p>
                            <span>{data.loan_status_change_date}</span>
                          </p>
                        </div>
                      );
                    }) : ""}
                  <br />
                </div>
                <h4 style={{ width: "100%", textAlign: "center" }}>
                  UPDATE STATUS
                </h4>
                <form onSubmit={handleSaveData}>
                  <div className="lms-table-div-modal">
                    <div>
                      <label>
                        Loan Status <span style={{ color: "red" }}>*</span>
                      </label>
                      <br></br>
                      <TextField
                        className="report-field"
                        required
                        placeholder="Select Data..."
                        select
                        name="status-type"
                        variant="outlined"
                        value={loanStatus}
                        size="small"
                        sx={{ width: "50ch", backgroundColor: "white" }}
                        onChange={(e) => setloanStatus(e.target.value)}
                      >
                        <MenuItem value="CPV DONE">CPV DONE</MenuItem>
                      </TextField>
                    </div>
                    <br></br>
                  
                    {(currentAddressVisible || officeAddressVisible || permanentAddressVisible) && (
                     <>
                    {currentAddressVisible && (
                      <>
                    <div>
                      <label>Current Address CPV</label>
                      <br></br>
                      <TextField
                        className="report-field"
                        placeholder="Select Data..."
                        select
                        name="status-type"
                        variant="outlined"
                        value={currentAddressCPV}
                        size="small"
                        sx={{ width: "50ch", backgroundColor: "white" }}
                        onChange={(e) => setcurrentAddressCPV(e.target.value)}
                      >
                        <MenuItem value="POSITIVE">Positive</MenuItem>
                        <MenuItem value="NEGATIVE">Negative</MenuItem>
                        <MenuItem value="REFER TO CREDIT">
                          Refer to Credit:User can select one of the above
                          Options
                        </MenuItem>
                      </TextField>
                    </div>
                    <br></br>
                    <input
                      type="file"
                      onChange={(e) => uploadCurrentAddress(e)}
                    ></input>
                    <br />
                    <br />
                    </>
                    )}

                    {officeAddressVisible && (
                      <>
                    <div>
                      <label>Office Address CPV</label>
                      <br></br>
                      <TextField
                        className="report-field"
                        placeholder="Select Data..."
                        select
                        name="status-type"
                        variant="outlined"
                        value={officeAddressCPV}
                        size="small"
                        sx={{ width: "50ch", backgroundColor: "white" }}
                        onChange={(e) => setofficeAddressCPV(e.target.value)}
                      >
                        <MenuItem value="POSITIVE">Positive</MenuItem>
                        <MenuItem value="NEGATIVE">Negative</MenuItem>
                        <MenuItem value="REFER TO CREDIT">
                          Refer to Credit:User can select one of the above
                          Options
                        </MenuItem>
                      </TextField>
                    </div>
                    <br></br>
                    <input
                      type="file"
                      onChange={(e) => uploadOfficeAddress(e)}
                    ></input>
                    <br />
                    <br />
                    </>
                    )}

                    {permanentAddressVisible && (
                         <>
                    <div>
                      <label>Permanent Address CPV</label>
                      <br></br>
                      <TextField
                        className="report-field"
                        placeholder="Select Data..."
                        select
                        name="status-type"
                        variant="outlined"
                        value={permanentAddressCPV}
                        size="small"
                        sx={{ width: "50ch", backgroundColor: "white" }}
                        onChange={(e) => setpermanentAddressCPV(e.target.value)}
                      >
                        <MenuItem value="POSITIVE">Positive</MenuItem>
                        <MenuItem value="NEGATIVE">Negative</MenuItem>
                        <MenuItem value="REFER TO CREDIT">
                          Refer to Credit:User can select one of the above
                          Options
                        </MenuItem>
                      </TextField>
                    </div>
                    <br />
                    <input
                      type="file"
                      onChange={(e) => uploadPermanentAddress(e)}
                    ></input>
                    <br />
                    <br />
                    </>
                     )}
                     </>
                     )}
                   
                    <div>
                      <label>
                        Description <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <textarea
                        required
                        value={description}
                        cols="50"
                        rows="3"
                        onChange={(e) => setdescription(e.target.value)}
                      />
                    </div>
                  </div>

                  <button className="save-modal" type="submit">
                    Save
                  </button>

                  <button className="cancel-modal" onClick={cancelFunction}>
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default CpvCases;
